<template>
  <div>
    <FormComponent
      @searchForm="getFormData"
      :searchFormItem="formItem"
      :labelWidth="120"
      ref="FormComponent"
      @handleReset="handleReset"
      :fileHidden="false"
    >
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot1">
        <FormItem :label="$t('In_position_since_ri')"
          ><!-- 本岗位开始日 -->
          <DatePicker
            type="date"
            v-model="formItem.changeDate"
            @on-change="formItem.changeDate = $event"
            style="width:100%"
            clearable
          ></DatePicker>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot1">
        <FormItem :label="$t('WHAT_Assessment_PPT')"
          ><!-- WHAT评分 -->
          <Select v-model="formItem.whatScore" clearable>
            <Option v-for="item in Score" :value="item.code" :key="item.code">{{
              lang == "zh" ? item.ch_value : item.en_value
            }}</Option>
          </Select>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot2">
        <FormItem :label="$t('HOW_Assessment_PPT')"
          ><!-- HOW评分 -->
          <Select v-model="formItem.howScore" clearable>
            <Option v-for="item in Score" :value="item.code" :key="item.code">{{
              lang == "zh" ? item.ch_value : item.en_value
            }}</Option>
          </Select>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot3">
        <FormItem :label="$t('Overall_Assessment_PPT')"
          ><!-- Overall评分 -->
          <Select v-model="formItem.wholeScore" clearable>
            <Option v-for="item in Score" :value="item.code" :key="item.code">{{
              lang == "zh" ? item.ch_value : item.en_value
            }}</Option>
          </Select>
        </FormItem>
      </Col>
      <!-- 当年度>2025年之后 潜能评分列就隐藏不要显示了 -->
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot4" v-if="isShowPotentialScore">
        <FormItem :label="$t('Potential_Rating')"
          ><!-- 潜能评分 -->
          <Select v-model="formItem.potentialScore" clearable>
            <Option
              v-for="item in PotentialScore"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot5">
        <FormItem :label="$t('PB_Calibration_Status')"
          ><!-- 校准状态 -->
          <Select v-model="formItem.checkStatus" clearable>
            <Option
              v-for="item in CheckStatus"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot6">
        <FormItem :label="$t('Management_Level')"
          ><!-- 管理层级 -->
          <Select v-model="formItem.hrmanage" clearable>
            <Option
              v-for="item in ManagementLevel"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col>
      <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot7">
        <FormItem :label="$t('Carlsberg_Band')"
          ><!-- 嘉士伯级别 -->
          <Select v-model="formItem.hcmBand" clearable>
            <Option v-for="item in Band" :value="item.code" :key="item.code">{{
              lang == "zh" ? item.ch_value : item.en_value
            }}</Option>
          </Select>
        </FormItem>
      </Col>
      <!-- 在职状态 -->
      <!-- <Col :xs="24" :sm="24" :md="12" :lg="6" slot="slot8">
        <FormItem :label="$t('PB_Employment_Status')">
          <Select v-model="formItem.beQuit" clearable style="width:100%">
            <Option
              v-for="item in BeQuit"
              :value="item.code"
              :key="item.code"
              >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
            >
          </Select>
        </FormItem>
      </Col> -->
    </FormComponent>
    <Tabs
      name="sub-tab"
      type="card"
      :animated="false"
      value="name1"
      @on-click="tabClick"
      style="margin-top:20px"
    >
      <TabPane
        :label="$t('PB_Normal_Distribution_of_Performance')"
        name="name1"
        tab="sub-tab"
        ><!-- 绩效正态评估 -->
        <Card>
          <div class="chartMain">
            <div class="chartBox">
              <div
                ref="barLeftChart"
                id="barLeftChart"
                :style="{ width: '85vw', height: '360px' }"
              ></div>
            </div>
            <div class="chartTable" style="width:70%">
              <Table
                border
                size="small"
                :span-method="handleSpan"
                :columns="columnsChart"
                :data="dataTable"
                style="margin:20px 0"
              ></Table>
            </div>
          </div>
        </Card>
        <Spin size="large" fix v-if="loading"></Spin>
      </TabPane>
      <TabPane
        :label="$t('Fifteen_Grid')"
        name="name2"
        tab="sub-tab"
        v-if="showDiv"
        ><!-- 十五宫格 -->
        <Card>
          <div class="chartBox">
            <RadioGroup v-model="radioValue" @on-change="radioChange">
              <Radio label="1" :value="true"
                ><!-- 人员占比 -->{{ $t("Proportion_User") }}</Radio
              >
              <Radio label="2"><!-- 人员数据 -->{{ $t("Employees") }}</Radio>
            </RadioGroup>
            <AchAssessComponentProportion
              v-show="radioValue == 1"
              ref="AchAssessComponentProportion"
            ></AchAssessComponentProportion>
            <Spin size="large" fix v-if="tabShow"></Spin>
            <AchAssessComponentCell
              @saveScore="saveScore"
              v-show="radioValue == 2"
              ref="AchAssessComponentCell"
            ></AchAssessComponentCell>
          </div>
        </Card>
        <!-- <Spin fix v-show="tabShow"></Spin> -->
      </TabPane>
      <TabPane
        :label="$t('TwentyFive_Grid')"
        name="name3"
        tab="sub-tab"
        v-if="showDiv2"
        ><!-- 二十五宫格 -->
        <Card>
          <div class="chartBox">
            <RadioGroup v-model="radioValue2" @on-change="radioChange2">
              <Radio label="1" :value="true"
                ><!-- 人员占比 -->{{ $t("Proportion_User") }}</Radio
              >
              <Radio label="2"><!-- 人员数据 -->{{ $t("Employees") }}</Radio>
            </RadioGroup>
            <AchAssessComponentProportion2
              v-show="radioValue2 == 1"
              ref="AchAssessComponentProportionRef"
            ></AchAssessComponentProportion2>
            <Spin size="large" fix v-if="tabShow"></Spin>
            <AchAssessComponentCell2
              @saveScore="saveScore"
              @onShowMore="onShowMore"
              v-show="radioValue2 == 2"
              ref="AchAssessComponentCellRef"
            ></AchAssessComponentCell2>
          </div>
        </Card>
      </TabPane>

    </Tabs>
    <div
      style="display:flex;justify-content: space-between;align-items: center;width:100%; margin-top:40px;margin-bottom:20px"
    >
      <Button
        type="primary"
        @click="showAllStatus = true"
        :disabled="beEnd == 1 || beEnd == 4"
        v-if="showreturnbtn"
        ><!-- 批量更新校准状态 -->{{
          $t("PB_Update_Calibration_Status")
        }}</Button
      >
      <div>
        <Button
          type="primary"
          v-if="isChinaOD == '1'"
          @click="pushClick"
          :disabled="loading"
          ><!-- 推送 -->{{ $t("Push") }}</Button
        >
        <Button
          type="primary"
          @click="saveTable"
          :disabled="beEnd == '1' || loading || beEnd == 4"
          v-if="showreturnbtn"
          ><!-- 保存 -->{{ $t("Save") }}</Button
        >
        <Button
          type="primary"
          @click="submitTable"
          :disabled="beEnd == '1' || loading || beEnd == 4"
          v-if="showreturnbtn"
          ><!-- 提交 -->{{ $t("Submit") }}</Button
        >
        <Button
          type="primary"
          @click="saveTable"
          v-if="!showreturnbtn"
          :disabled="loading"
          ><!-- 提交 -->{{ $t("Submit") }}</Button
        >
        <Button
          type="warning"
          v-if="!showreturnbtn && tabName != 'PerformanceEvaluation'"
          @click="returnSave"
          :disabled="loading"
          ><!-- 退回 -->{{ $t("Reject") }}</Button
        >
        <!-- <Button type="primary" style="margin-top:15px" @click="paceTable" :disabled="beEnd=='1'" v-if="showreturnbtn">激活PB Session</Button> -->
        <Button type="primary" @click="exportData" :disabled="loading"
          ><!-- 导出 -->{{ $t("PB_Export") }}</Button
        >
        <Button
          type="primary"
          @click="returnPage"
          v-if="showreturnbtn"
          :disabled="loading"
          ><!-- 返回 -->{{ $t("Return") }}</Button
        >
      </div>
    </div>
    <Table
      border
      :loading="loading"
      :columns="columns"
      :data="data"
      style="margin-bottom:20px"
      :max-height="tableheight"
      @on-select-cancel="TableSelectCancelRow"
      @on-select-all-cancel="cancelAll"
      @on-select-all="selsetAll"
      @on-select="peoOnSelectRow"
      ref="selectiona"
    >
      <template
        slot-scope="{ row, index }"
        slot="checkStatus"
        style="width:100%"
      >
        <Select
          v-model="row.checkStatus"
          clearable
          @on-change="targetItemChange(row, index, 'checkStatus')"
          transfer
          :disabled="row.selsetDisabled"
        >
          <Option
            v-for="item in CheckStatus"
            :value="item.code"
            :key="item.code"
            >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
          >
        </Select>
      </template>
      <template slot-scope="{ row, index }" slot="userName" style="width:100%">
        <Button type="primary" size="small" @click="showCard(row, index)">{{
          row.userName
        }}</Button>
      </template>
      <template slot-scope="{ row }" slot="dirSupName" style="width:100%">
        <Button type="primary" size="small" @click="showNewPage(row)">{{
          row.dirSupName
        }}</Button>
      </template>
      <template slot-scope="{ row, index }" slot="whatScore" style="width:100%">
        <Select
          v-model="row.whatScore"
          @on-change="targetItemChange(row, index, 'whatScore')"
          transfer
          :disabled="row.selsetDisabled"
        >
          <Option v-for="item in Score" :value="item.code" :key="item.code">{{
            lang == "zh" ? item.ch_value : item.en_value
          }}</Option>
        </Select>
      </template>
      <template slot-scope="{ row, index }" slot="howScore" style="width:100%">
        <Select
          v-model="row.howScore"
          @on-change="targetItemChange(row, index, 'howScore')"
          transfer
          :disabled="row.selsetDisabled"
        >
          <Option v-for="item in Score" :value="item.code" :key="item.code">{{
            lang == "zh" ? item.ch_value : item.en_value
          }}</Option>
        </Select>
      </template>
      <template
        slot-scope="{ row, index }"
        slot="wholeScore"
        style="width:100%"
      >
        <Select
          v-model="row.wholeScore"
          @on-change="targetItemChange(row, index, 'wholeScore')"
          transfer
          disabled
        >
          <Option v-for="item in Score" :value="item.code" :key="item.code">{{
            lang == "zh" ? item.ch_value : item.en_value
          }}</Option>
        </Select>
      </template>
      <template
        slot-scope="{ row, index }"
        slot="potentialScore"
        style="width:100%"
      >
        <Select
          v-model="row.potentialScore"
          @on-change="targetItemChange(row, index, 'potentialScore')"
          transfer
          :disabled="row.selsetDisabled"
        >
          <Option
            v-for="item in PotentialScore"
            :value="item.code"
            :key="item.code"
            >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
          >
        </Select>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button
          type="primary"
          icon="md-reorder"
          size="small"
          :disabled="!row.achApplyId || row.achApplyId == 'NotFindApplyId'"
          @click="checkBtn(row, index)"
        ></Button>
      </template>
    </Table>
    <Table
      :columns="columnsA"
      :data="exportTableData"
      ref="Table"
      id="Table"
      v-show="false"
    ></Table>

    <div
      style="margin:10px 0 20px 0;display:flex; justify-content: flex-end;flex-direction: column; align-items: flex-end;"
    >
      <div
        style="display:flex;justify-content:flex-end;align-items: center;width:100%"
      >
        <Page
          :total="total"
          :current="pageInfo.pageNo"
          :page-size="pageInfo.pageSize"
          @on-change="pageChange"
          :page-size-opts="[10, 50, 100, 150]"
          show-sizer
          @on-page-size-change="pageSizeChange"
        />
      </div>
      <div
        style="display:flex;justify-content: space-between;align-items: center;width:100%"
      >
        <Button
          type="primary"
          @click="showAllStatus = true"
          :disabled="beEnd == 1 || beEnd == 4"
          v-if="showreturnbtn"
          ><!-- 批量更新校准状态 -->{{
            $t("PB_Update_Calibration_Status")
          }}</Button
        >
        <div>
          <Button
            type="primary"
            style="margin-top:15px"
            v-if="isChinaOD == '1'"
            @click="pushClick"
            :disabled="loading"
            ><!-- 推送 -->{{ $t("Push") }}</Button
          >
          <Button
            type="primary"
            style="margin-top:15px"
            @click="saveTable"
            :disabled="beEnd == '1' || loading || beEnd == 4"
            v-if="showreturnbtn"
            ><!-- 保存 -->{{ $t("Save") }}</Button
          >
          <Button
            type="primary"
            style="margin-top:15px"
            @click="submitTable"
            :disabled="beEnd == '1' || loading || beEnd == 4"
            v-if="showreturnbtn"
            ><!-- 提交 -->{{ $t("Submit") }}</Button
          >
          <Button
            type="primary"
            style="margin-top:15px"
            @click="saveTable"
            v-if="!showreturnbtn"
            :disabled="loading"
            ><!-- 提交 -->{{ $t("Submit") }}</Button
          >
          <Button
            type="warning"
            style="margin-top:15px"
            v-if="!showreturnbtn && tabName != 'PerformanceEvaluation'"
            @click="returnSave"
            :disabled="loading"
            ><!-- 退回 -->{{ $t("Reject") }}</Button
          >
          <!-- <Button type="primary" style="margin-top:15px" @click="paceTable" :disabled="beEnd=='1'" v-if="showreturnbtn">激活PB Session</Button> -->
          <Button
            type="primary"
            style="margin-top:15px"
            @click="exportData"
            :disabled="loading"
            ><!-- 导出 -->{{ $t("PB_Export") }}</Button
          >
          <Button
            type="primary"
            style="margin-top:15px"
            @click="returnPage"
            v-if="showreturnbtn"
            :disabled="loading"
            ><!-- 返回 -->{{ $t("Return") }}</Button
          >
        </div>
      </div>
    </div>

    <Modal v-model="isShowDetal" :closable="false" fullscreen class="tab"
      ><!-- 人才卡片 -->
      <Tabs
        type="card"
        :value="showTabDetal"
        v-model="showTabDetal"
        :animated="true"
        name="talentCard"
      >
        <TabPane
          :label="$t('PB_Talent_Card')"
          name="a"
          :index="7"
          class="taletTab"
          tab="talentCard"
          v-if="isShowDetal"
          ><j2-talentCard
            ref="talentCard"
            v-if="isShowDetal"
            @back="isShowDetal = false"
          ></j2-talentCard
        ></TabPane>
        <TabPane
          :label="$t('PB_Performance__Sheet')"
          name="b"
          :index="8"
          class="taletTab"
          tab="talentCard"
          v-if="isShowDetal && isShowApplyForm"
          ><!-- 绩效表单 -->
          <j2-MyAchievements
            ref="MyAchievements"
            v-if="isShowDetal && isShowApplyForm"
          ></j2-MyAchievements>
        </TabPane>
        <div slot="extra">
          <Page
            :current="cardInit"
            :total="total"
            :page-size="1"
            simple
            prev-text="上一页"
            next-text="下一页"
            @on-change="cardChange"
          />
          <!-- <Button @click="prevPage" : size="small" >上一页</Button>
              <Button @click="nextPage" size="small" >下一页</Button> -->
        </div>
      </Tabs>

      <div slot="footer">
        <Button type="text" @click="(isShowDetal = false), (showTabDetal = 'a')"
          ><!-- 返回 -->{{ $t("Return") }}</Button
        >
      </div>
    </Modal>
    <Modal
      v-model="showAllStatus"
      :title="$t('PB_Update_Calibration_Status')"
      width="400px"
      @on-ok="allStatusSave"
      ><!-- 批量更新校准状态 -->
      <Select clearable v-model="checkStatus" transfer>
        <Option
          v-for="item in CheckStatus"
          :value="item.code"
          :key="item.code"
          >{{ item.ch_value }}</Option
        >
      </Select>
    </Modal>
    <ApprovalRemark ref="ApprovalRemark" @ok="okSave"></ApprovalRemark>
    <Modal v-model="sessionModal" :title="$t('longText32')"
      ><!-- 未提交初评结果的人员名单，及直线经理 -->
      <Table
        border
        size="small"
        :columns="modalColumns"
        :data="sessionData"
        style="margin:20px 0"
      ></Table>
      <div style="display:flex;justify-content: flex-end;width:100%">
        <Page :total="total1" @on-change="pageChange1" />
      </div>

      <div slot="footer">
        <Button @click="sessionModal = false"
          ><!-- 取消 -->{{ $t("Cancel") }}</Button
        >
      </div>
    </Modal>

    <Modal
      v-model="checkScoreModel"
      title="提示"
      :loading="loading"
      @on-ok="saveTableData"
    >
      <p v-for="(item, index) in checkScoreList" :key="index">
        {{ this.$t("Emp_Ach_mess27") }}{{ item.userName }}员工（{{
          item.empCode
        }}）的评分不符合规则，确认是否提交？
      </p>
    </Modal>
    <Modal
      v-model="warnModalValue"
      :title="this.$t('Emp_Ach_mess27')"
      :loading="loading"
      @on-ok="submitTableTwo"
      width="800"
    >
      <div style="font-size: 18px;">
        {{ this.$t("submitPeoPleBoardCheck") }}
      </div>
      <Table :columns="warnColumns" :data="warnData" border> </Table>
    </Modal>
  </div>
</template>

<script>
import FormComponent from "../components/FormComponent.vue";
import AchAssessComponentCell from "../components/AchAssessComponentCell.vue";
import AchAssessComponentCell2 from "../components/AchAssessComponentCell2.vue";
import AchAssessComponentProportion from "../components/AchAssessComponentProportion.vue";
import AchAssessComponentProportion2 from "../components/AchAssessComponentProportion2.vue";
import axios from "axios";
import "./../js/westeros.js";
import DateUtil from "@/util/DateUtil";
import ApprovalRemark from "../components/modalComponents/ApprovalRemark.vue";
export default {
  components: {
    FormComponent,
    AchAssessComponentCell,
    AchAssessComponentCell2,
    AchAssessComponentProportion,
    AchAssessComponentProportion2,
    ApprovalRemark
  },
  data() {
    return {
      date: new DateUtil(),
      warnModalValue: false,
      warnData: [],
      showreturnbtn: false,
      prevent: false,
      formItem: {
        whatScore:"",
        howScore:"",
        wholeScore:"",
      },
      searchItem: {},
      selectList: [],
      loading: false,
      total: 0,
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 150
      },
      data: [],
      modalColumns: [
        {
          title: "员工姓名",
          key: "userName",
          align: "center",
          minWidth: 100
        },
        {
          title: "直线经理",
          key: "dirSupName",
          align: "center",
          minWidth: 160
        }
      ],
      dataTable: [],
      dataChart: [],
      spinShow: false,
      radioValue: "1",
      id: "",
      lineData: [],
      Score: [],
      tabName: "",
      exportTableData: [],
      selectList: [],
      PotentialScore: [],
      ManagementLevel: [],
      Band: [],
      isChinaOD: "",
      returnState: false,
      beEnd: "0",
      isShowDetal: false,
      isShowApplyForm:false,
      CheckStatus: [],
      showAllStatus: false,
      showAllStatusDisabled: false,
      checkStatus: "",
      achPeopleBoardList: [],
      showDiv: true,
      sessionModal: false,
      sessionData: [],
      BeQuit: [],
      total1: 0,
      pageInfo1: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      cardInit: 0,
      cardIndex: 0,
      tabShow: false,
      tabClickSatae: false,
      allData: [],
      showTabDetal: "a",
      radioIndex: "1",
      tableheight: 0,
      checkScoreModel: false,
      checkScoreList: [],
      showDiv2:false,
      radioValue2: "1",
      radioIndex2: "1",
      isShowPotentialScore: true
    };
  },
  computed: {
    warnColumns() {
      return [
        {
          title: this.$t("Meeting_Subjects") /* 会议名称 */,
          key: "mettingName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("applyUserId") /* 员工工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("userName") /* 会议名称 */,
          key: "userName",
          align: "center",
          minWidth: 120
        }
      ];
    },
    lang() {
      return this.$store.getters.selectLangeData;
    },
    columns() {
      let arr = [
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: this.$t("PB_Performance__Sheet") /* 绩效表单 */,
          key: "action",
          slot: "action",
          align: "center",
          minWidth: 120,
          sortable: true
        },
        {
          title: this.$t("PB_Calibration_Status") /* 校准状态 */,
          key: "checkStatus",
          slot: "checkStatus",
          align: "center",
          minWidth: 160,
          sortable: true
        },
        {
          title: this.$t("BU") /* 业务单元 */,
          key: this.lang == "zh" ? "businessUnit" : "enBusinessUnit",
          align: "center",
          minWidth: 120,
          sortable: true
        },
        {
          title: this.$t("Department") /* 部门 */,
          key: this.lang == "zh" ? "department" : "enDepartment",
          align: "center",
          minWidth: 120,
          sortable: true
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120,
          sortable: true
        },
        {
          title: this.$t("Chinese_Name") /* 中文姓名 */,
          key: "userName",
          slot: "userName",
          align: "center",
          minWidth: 160,
          sortable: true
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 120,
          sortable: true
        },
        {
          title: this.$t("Position_Name_Chinese") /* 职位名称（中文） */,
          key: "position",
          align: "center",
          minWidth: 120,
          sortable: true
        },
        {
          title: this.$t("Position_Name_English") /* 职位名称（英文） */,
          key: "positionETitle",
          align: "center",
          minWidth: 120,
          sortable: true
        },
        {
          title: this.$t("Line_Manager") /* 直线上级 */,
          key: "dirSupName",
          slot: "dirSupName",
          align: "center",
          minWidth: 160,
          sortable: true
        },
        {
          title: this.$t("In_position_since_ri") /* 本岗位开始日 */,
          key: "changeDate",
          align: "center",
          minWidth: 160
        },
        {
          title: this.$t("PB_Resign_Date") /* 离职日期 */,
          key: "quitDate",
          align: "center",
          minWidth: 160,
          sortable: true
        },
        {
          title: this.$t("WHAT_Assessment_PPT") /* WHAT评分 */,
          key: "whatScore",
          slot: "whatScore",
          align: "center",
          minWidth: 160,
          sortable: true
        },
        {
          title: this.$t("HOW_Assessment_PPT") /* HOW评分 */,
          key: "howScore",
          slot: "howScore",
          align: "center",
          minWidth: 160,
          sortable: true
        },
        {
          title: this.$t("Overall_Assessment_PPT") /* Overall评分 */,
          key: "wholeScore",
          slot: "wholeScore",
          align: "center",
          minWidth: 160,
          sortable: true
        },
        {
          title: this.$t("Potential_Rating") /* 潜能评分 */,
          key: "potentialScore",
          slot: "potentialScore",
          align: "center",
          minWidth: 160,
          sortable: true,
          isHide: this.showDiv2 ||  !this.isShowPotentialScore //当年度>2025年之后 潜能评分列就隐藏不要显示了
        }
      ];
      return arr.filter(item => !item.isHide)
    },
    columnsA() {
      let arr = [
        {
          title: this.$t("PB_Calibration_Status") /* 校准状态 */,
          key: "checkStatus",
          align: "center",
          minWidth: 160,
          render: (h, params) => {
            return h(
              "span",
              this.CheckStatus &&
                this.CheckStatus.filter(
                  item => params.row.checkStatus == item.code
                ).map(res => res.ch_value)
            );
          }
        },
        {
          title: this.$t("BU") /* 业务单元 */,
          key: this.lang == "zh" ? "businessUnit" : "enBusinessUnit",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Department") /* 部门 */,
          key: this.lang == "zh" ? "department" : "enDepartment",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Employee_Code") /* 员工号 */,
          key: "empCode",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Chinese_Name") /* 中文姓名 */,
          key: "userName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("English_Name") /* 英文名 */,
          key: "userEName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Position_Name_Chinese") /* 职位名称（中文） */,
          key: "position",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Position_Name_English") /* 职位名称（英文） */,
          key: "positionETitle",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Line_Manager") /* 直线上级 */,
          key: "dirSupName",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("In_position_since_ri") /* 本岗位开始日 */,
          key: "changeDate",
          align: "center",
          minWidth: 100
        },
        {
          title: this.$t("PB_Resign_Date") /* 离职日期 */,
          key: "quitDate",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("WHAT_Assessment_PPT") /* WHAT评分 */,
          key: "whatScore",
          align: "center",
          minWidth: 160
        },
        {
          title: this.$t("HOW_Assessment_PPT") /* HOW评分 */,
          key: "howScore",
          align: "center",
          minWidth: 160
        },
        {
          title: this.$t("Overall_Assessment_PPT") /* Overall评分 */,
          key: "wholeScore",
          align: "center",
          minWidth: 160
        },
        {
          title: this.$t("Potential_Rating") /* 潜能评分 */,
          key: "potentialScore",
          align: "center",
          minWidth: 160,
          isHide: this.showDiv2 || !this.isShowPotentialScore //当年度>2025年之后 潜能评分列就隐藏不要显示了
        }
      ];
      return arr.filter(item => !item.isHide)
    },
    columnsChart() {
      return [
        {
          title: this.$t("Items") /* 评分项目 */,
          key: this.lang == "zh" ? "scopeType" : "enScopeType",
          align: "center",
          minWidth: 120,
          className: "demo-table-info-column"
        },
        {
          title: this.$t("PB_1-Requires_Improvement") /* 1-需要改善 */,
          key: "achNormal1",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("PB_2-Typically_Meets") /* 2-部分达标 */,
          key: "achNormal2",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("PB_3-Achieved") /* 3-达到要求 */,
          key: "achNormal3",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("PB_4-Exceeds") /* 4-超越要求 */,
          key: "achNormal4",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("PB_5-Exceptional") /* 5-优秀出色 */,
          key: "achNormal5",
          align: "center",
          minWidth: 120
        }
      ];
    },
    lang() {
      return this.$store.getters.selectLangeData;
    }
  },
  mounted() {
    // this.getListData()
    this.$nextTick(() => {
      this.$refs.FormComponent.levelDisabledState = true;
      this.$refs.FormComponent.levelDisabled = true;
      this.$refs.FormComponent.pShow = true;
    });
    this.tableheight = window.innerHeight - 200;
    window.onresize = () => {
      return (() => {
        this.tableheight = window.innerHeight - 200;
      })();
    };

    // 当年度>2025年之后 潜能评分列就隐藏不要显示了
    this.isShowPotentialScore = true
    if(this.$route.query.year > '2025') {
        this.isShowPotentialScore = false
    }

  },

  created() {
    this.searchItem.year = JSON.parse(sessionStorage.getItem("userInfo")).year;
  },
  watch: {
    "$i18n.locale"(newValue) {
      this.barLeftChart();
    }
  },
  methods: {
    onShowMore(e = {}) {
      this.formItem.whatScore = e.whatScope
      this.formItem.howScore = e.howScope
      this.formItem.wholeScore = e.wholeScope
      this.getFormData(JSON.stringify(this.formItem))
    },
    barLeftChart() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(
        document.getElementById("barLeftChart"),
        "westeros"
      );
      // 绘制图表
      myChart.setOption({
        title: {
          text: this.$t("Normal_Distribution_of_Performance"),
          left: "center",
          top: "0"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: {
          left: "4%",
          right: "10%",
          top: "10%",
          bottom: "10%"
        },
        xAxis: [
          {
            type: "category",
            // data: ["1-需要改善","2-部分达标","3-达到要求","4-超越要求","5-优秀出色"],
            data: [
              this.$t("PB_1-Requires_Improvement"),
              this.$t("PB_2-Typically_Meets"),
              this.$t("PB_3-Achieved"),
              this.$t("PB_4-Exceeds"),
              this.$t("PB_5-Exceptional")
            ],
            axisPointer: {
              type: "shadow"
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            max:
              this.total.toString().length == 1
                ? 10
                : this.total >= 10 && this.total < 50
                ? 50
                : this.total >= 50 && this.total <= 100
                ? 100
                : this.total.toString().length == 3
                ? 1000
                : this.total.toString().length == 4
                ? 10000
                : 100000,
            interval:
              this.total.toString().length == 1
                ? 1
                : this.total >= 10 && this.total < 50
                ? 5
                : this.total >= 50 && this.total <= 100
                ? 10
                : this.total.toString().length == 3
                ? 100
                : this.total.toString().length == 4
                ? 1000
                : 10000
            // axisLabel: {
            //   formatter: "{value}"
            // }
          }
          // {
          //   type: "value",
          //   min: 0,
          //   max: 100,
          //   interval: 10,
          //   axisLabel: {
          //     formatter: "{value}%"
          //   }
          // }
        ],

        series: [
          {
            name: this.$t("Number"),
            type: "bar",
            barWidth: "50%",
            color: "#4ea397",
            data: [
              {
                value: this.dataChart[0].peopleNum,
                itemStyle: {
                  color: "#A5A5A5"
                }
              },
              {
                value: this.dataChart[1].peopleNum,
                itemStyle: {
                  color: "#D9A300"
                }
              },
              {
                value: this.dataChart[2].peopleNum,
                itemStyle: {
                  color: "#8CD29B"
                }
              },
              {
                value: this.dataChart[3].peopleNum,
                itemStyle: {
                  color: "#fc8637"
                }
              },
              {
                value: this.dataChart[4].peopleNum,
                itemStyle: {
                  color: "#4472C4"
                }
              }
            ]
          },
          {
            name: this.$t("Number"),
            type: "line",
            color: "#006B37",
            data: this.lineData,
            tooltip: {
              show: false
            }
          }
        ]
      });
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    },

    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then(res => {
        if (res) {
          this.$refs.FormComponent.positionList = res.positionList;
          this.$refs.FormComponent.departmentList = res.departmentList;
          this.$refs.FormComponent.businessUnitList = res.businessUnitList;
          this.$refs.FormComponent.salesAreaList = res.salesAreaList;
          this.$refs.FormComponent.YesOrNo = res.YesOrNo;
          this.$refs.FormComponent.BeQuit = res.BeQuit;
          this.$refs.FormComponent.Level = res.Level;
          this.Score = res.Score;
          this.PotentialScore = res.PotentialScore;
          this.showDiv
            ? (this.$refs.AchAssessComponentCell.Score = res.Score)
            : "";
          this.showDiv
            ? (this.$refs.AchAssessComponentCell.PotentialScore =
                res.PotentialScore)
            : "";
          this.CheckStatus = res.CheckStatus;
          this.ManagementLevel = res.ManagementLevel;
          this.Band = res.Band;
          this.$refs.FormComponent.functionList = res.functionList;
          this.BeQuit = res.BeQuit;
          this.overallScoreList = res.overallScoreList;
          if(this.showDiv) {
            this.$refs.AchAssessComponentCell.overallScoreList = res.overallScoreList
          }

          if(this.showDiv2) {
            this.$refs.AchAssessComponentCellRef.Score = res.Score
            this.$refs.AchAssessComponentCellRef.PotentialScore = res.PotentialScore
            this.$refs.AchAssessComponentCellRef.overallScoreList = res.overallScoreList
          }

        }
      });
    },
    getFormData(item) {
      this.pageInfo.pageNo = 1;
      this.getData(item);
    },
    getData(item) {
      item ? (this.searchItem = JSON.parse(item)) : "";
      let obj = {
        id: this.id,
        ...this.pageInfo,
        ...this.searchItem
      };
      let url = "";
      this.loading = true;
      this.tabShow = true;
      url = "/AchPeopleBoard/selectAchPeopleBoard";
      this.lineData = [];
      this.dataTable = [];
      axios.post(url, obj).then(res => {
        this.$refs.FormComponent.prevent = false;
        this.loading = false;
        this.tabShow = false;
        if (res) {
          this.data = res.achPeopleBoardList;
          this.cardData = res.achPeopleBoardList;
          this.allData = res.allData;
          this.total = parseInt(res.pageInfo.total);
          if (res.normalTableList) {
            this.dataTable = res.normalTableList;
          }
          this.beEnd = res.beEnd;
          if (res.achNormalList) {
            this.dataChart = res.achNormalList;
            this.dataChart.forEach(el => {
              this.lineData.push(el.peopleNum);
            });
            this.$nextTick(() => {
              this.barLeftChart();
            });
          } else {
            this.dataChart = [
              { peopleNum: 0 },
              { peopleNum: 0 },
              { peopleNum: 0 },
              { peopleNum: 0 },
              { peopleNum: 0 }
            ];
            this.lineData = [0, 0, 0, 0, 0];
            this.$nextTick(() => {
              this.barLeftChart();
            });
          }

          this.data.forEach((el, index) => {
            el._disabled = false;
            el.selsetDisabled = false;
            // if(res.isChinaOD  == 1){
            //   if(el.disabledFlag !=0 && el.statusCode !=6 ){
            //     el._disabled = true
            //   }
            // }else {
            //     if (el.disabledFlag=='1') {
            //       el._disabled = true
            //       // this.$refs.selection.objData[index]._Disabled = true
            //     }
            // }
            if (res.beEnd == "1") {
              el.selsetDisabled = true;
              el._disabled = true;
              // this.showDiv?this.$refs.AchAssessComponentCell.beEnd='1':''
            }
          });
          this.$nextTick(() => {
            this.achPeopleBoardList.forEach(res => {
              this.data.forEach((el, index) => {
                el._checked = false;
                if (el.id === res.id) {
                  this.$refs.selectiona.objData[index]._isChecked = true;
                }
              });
            });
          });

          // this.showDiv?this.$refs.AchAssessComponentProportion.data=res.fifteenTableList:''
          // this.showDiv?this.$refs.AchAssessComponentCell.data=res.fifteenTableList:''

          this.isChinaOD = res.isChinaOD;
          if (this.tabClickSatae) {
            //十五宫格
            if(this.showDiv) {
             this.getfifData(this.radioIndex);
            }
            //二十五宫格
            if(this.showDiv2) {
             this.getfifData2(this.radioIndex2);
            }
          }
        }
      });
    },
    tabClick(val) {
      if (val == "name2") {
        this.tabClickSatae = true;
        this.getfifData(this.radioIndex);
      }else if(val == "name3") {
        this.tabClickSatae = true;
        this.getfifData2(this.radioIndex2);
      } else {
        this.tabClickSatae = false;
      }
    },
    radioChange(val) {
      this.radioIndex = val;
      this.getfifData(val);
    },
    getfifData(val) {
      let obj = {
        id: this.id,
        ...this.searchItem,
        allData: this.allData,
        type: val
      };
      this.tabShow = true;
      axios.post("/achReport/selectFifteenTableData", obj).then(res => {
        if (res) {
          if (val == "1") {
            this.$refs.AchAssessComponentProportion.data = res;
            this.$refs.AchAssessComponentProportion.allData = this.allData;
          } else {
            this.$refs.AchAssessComponentCell.beEnd = this.beEnd;
            this.$refs.AchAssessComponentCell.data = res;
          }
        }
        this.tabShow = false;
      });
    },
    radioChange2(val) {
      this.radioIndex2 = val;
      this.getfifData2(val);
    },
    getfifData2(val) {
      let obj = {
        id: this.id,
        ...this.searchItem,
        allData: this.allData,
        type: val
      };
      this.tabShow = true;
      axios.post("/achReport/selectTwentyFiveTableData", obj).then(res => {
        this.tabShow = false;
        if (res) {
          if (val == "1") {
            this.$refs.AchAssessComponentProportionRef.data = res;
            this.$refs.AchAssessComponentProportionRef.allData = this.allData;
          } else {
            this.$refs.AchAssessComponentCellRef.beEnd = this.beEnd;
            this.$refs.AchAssessComponentCellRef.data = res;
          }
        }
      });
    },

    saveScore() {
      this.getData(JSON.stringify(this.searchItem));
    },
    getTabData() {},
    targetItemChange(row, index, key) {
      key && this.$set(this.data[index], key, row[`${key}`]);
      if(row.whatScore &&  row.howScore){
        this.$set(this.data[index], 'wholeScore', this.getOverallScore(row.whatScore , row.howScore));
      }
    },
    getOverallScore(whatScore,howScore){
      let overallScore = "";
      this.overallScoreList.forEach(res=>{
        if(whatScore == res.whatScore && howScore == res.howScore){
          overallScore =  res.overallScore
        }
      })  
      return overallScore
    },
    saveTable() {
      this.saveStatus = true;
      if (this.showreturnbtn) {
        this.checkScoreList = [];
        this.data.forEach(item => {
          if (!this.checkScore(item)) {
            this.checkScoreList.push(item);
          }
        });
        if (this.checkScoreList.length > 0) {
          this.checkScoreModel = true;
        } else {
          this.saveTableData();
        }
      } else {
        this.$refs.ApprovalRemark.modalShow = true;
        this.returnState = false;
      }
    },
    saveTableData() {
      if (this.saveStatus) {
        this.loading = true;
        axios
          .post("/AchPeopleBoard/savePeopleBoardScore", this.data)
          .then(res => {
            this.loading = false;
            if (res) {
              this.$Message.success(this.$t("Save_Successful"));
              this.getData(JSON.stringify(this.searchItem));
            }
          });
      } else {
        this.submitOk();
      }
    },
    checkScore(item) {
      let wholeScore = Number(item.wholeScore);
      let whatScore = Number(item.whatScore);
      let howScore = Number(item.howScore);
      // Overall分数不大于What或How的单项分数
      // 当What和How的分数差异大于1时，Overall的分数需在What和How的分数中间
      if (wholeScore > whatScore && wholeScore > howScore) {
        return false;
      } else if (
        whatScore - howScore > 1 &&
        (wholeScore >= whatScore || wholeScore <= howScore)
      ) {
        return false;
      } else if (
        howScore - whatScore > 1 &&
        (wholeScore >= howScore || wholeScore <= whatScore)
      ) {
        return false;
      }
      return true;
    },
    submitTableTwo() {
      this.checkScoreList = [];
      this.data.forEach(item => {
        if (!this.checkScore(item)) {
          this.checkScoreList.push(item);
        }
      });
      if (this.checkScoreList.length > 0) {
        this.checkScoreModel = true;
      } else {
        this.saveTableData();
      }
      this.warnModalValue = false;
    },
    //增加返回list有值 弹出 警告信息modal 否则按照原来进行
    submitTable() {
      this.saveStatus = false;
      let obj = {
        id: this.id,
        achPeopleBoardList: this.data
      };
      axios.post("/AchPeopleBoard/checkPeoPleBoardSubmit", obj).then(res => {
        if (res.dataList.length > 0) {
          this.warnModalValue = true;
          this.warnData = res.dataList;
        } else if (res.result && res.result == 0) {
          this.$Modal.confirm({
            title: "请确认提交校准结果，并结束会议",
            onOk: () => {
              this.checkScoreList = [];
              this.data.forEach(item => {
                if (!this.checkScore(item)) {
                  this.checkScoreList.push(item);
                }
              });
              if (this.checkScoreList.length > 0) {
                this.checkScoreModel = true;
              } else {
                this.saveTableData();
              }
              // this.submitOk()
            }
          });
        } else {
          this.getData(JSON.stringify(this.searchItem));
        }
      });
    },
    submitOk() {
      let obj = {
        id: this.id,
        achPeopleBoardList: this.data
      };
      this.loading = true;
      axios.post("/AchPeopleBoard/submitAchApproval", obj).then(res => {
        this.loading = false;
        if (res) {
          this.$Message.success(res);
          this.getData(JSON.stringify(this.searchItem));
        }
      });
    },
    okSave(val) {
      this.selectList.forEach(el => {
        (el.decision = this.returnState ? "2" : "1"), (el.idea = val);
      });
      axios
        .post("/AchPeopleBoard/submitPeopleBoardScore", this.selectList)
        .then(res => {
          if (res) {
            this.$Message.success(this.$t("sbumit_Success"));
            this.getData(JSON.stringify(this.searchItem));
          }
        });
    },

    pushClick() {
      axios.post("/AchPeopleBoard/chinaODSubmit", this.selectList).then(res => {
        if (res) {
          this.$Message.success("推送成功");
          this.getData(JSON.stringify(this.searchItem));
        }
      });
    },
    paceTable() {
      this.loading = true;
      axios
        .post("/AchPeopleBoard/synchronizationEvaResult", {
          id: this.id,
          year: this.searchItem.year || this.date.dateVal(new Date(), "YYYY")
        })
        .then(res => {
          if (res != null && res.length > 0) {
            this.sessionModal = true;
            this.loading = false;
            this.getSessionData();
          } else {
            if (res != null && res.length == 0) {
              this.$Message.success(this.$t("Emp_Ach_mess18"));
            }
            this.getData(JSON.stringify(this.searchItem));
          }
        });
    },
    getSessionData() {
      axios
        .post("/AchPeopleBoard/selectBeSubmitStartInfo", {
          ...this.pageInfo1,
          id: this.id,
          year: this.searchItem.year || this.date.dateVal(new Date(), "YYYY")
        })
        .then(res => {
          if (res) {
            this.sessionData = res.data;
            this.total1 = parseInt(res.pageInfo.total);
          }
        });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.saveTable();
      // this.getData(JSON.stringify(this.searchItem))
    },
    pageChange1(val) {
      this.pageInfo1.pageNo = val;
      this.getSessionData();
    },
    handleSpan({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0 && columnIndex === 1) {
        return [1, 2];
      } else if (rowIndex === 0 && columnIndex === 2) {
        return [0, 0];
      }
      if (rowIndex === 0 && columnIndex === 4) {
        return [1, 5];
      } else if (rowIndex === 0 && columnIndex === 5) {
        return [0, 0];
      }
      if (rowIndex === 2 && columnIndex === 0) {
        return {
          rowspan: 2,
          colspan: 1
        };
      } else if (rowIndex === 3 && columnIndex === 0) {
        return {
          rowspan: 0,
          colspan: 0
        };
      }
      if (rowIndex === 3 && columnIndex === 1) {
        return [1, 2];
      } else if (rowIndex === 3 && columnIndex === 2) {
        return [0, 0];
      }
      if (rowIndex === 3 && columnIndex === 4) {
        return [1, 2];
      } else if (rowIndex === 3 && columnIndex === 5) {
        return [0, 0];
      }
    },
    returnPage() {
      this.$router.back();
    },
    exportData() {
      let obj = {
        id: this.id,
        pageNo: 1,
        pageSize: 10000,
        ...this.searchItem
      };
      this.loading = true;
      axios.post("/AchPeopleBoard/selectAchPeopleBoard", obj).then(res => {
        if (res) {
          this.exportTableData = res.achPeopleBoardList;
          this.exportTableData.forEach(el => {
            el.checkStatus = this.CheckStatus.filter(
              item => el.checkStatus == item.code
            ).map(res => (this.lang == "zh" ? res.ch_value : res.en_value))[0];
            el.whatScore = this.Score.filter(
              item => el.whatScore == item.code
            ).map(res => (this.lang == "zh" ? res.ch_value : res.en_value))[0];
            el.howScore = this.Score.filter(
              item => el.howScore == item.code
            ).map(res => (this.lang == "zh" ? res.ch_value : res.en_value))[0];
            el.wholeScore = this.Score.filter(
              item => el.wholeScore == item.code
            ).map(res => (this.lang == "zh" ? res.ch_value : res.en_value))[0];
            el.potentialScore = this.PotentialScore.filter(
              item => el.potentialScore == item.code
            ).map(res => (this.lang == "zh" ? res.ch_value : res.en_value))[0];
          });
          this.$nextTick(() => {
            this.$exportExcel(
              "Table",
              "绩效评估" + this.$nowDate.dateVal(new Date(), "YYYY-MM-DD HH-mm")
            );
            // this.$refs.Table.exportCsv({
            //     filename: '绩效评估',
            // });
          });
        }
        this.loading = false;
      });
    },
    returnSave() {
      this.$refs.ApprovalRemark.modalShow = true;
      this.returnState = true;
    },
    checkBtn(row, index) {
      this.$router.push({
        path: "/01D12DA58A51C4D3259E1DE7BCAA10A6/A3FFBEBFDB713E27",
        query: {
          id: row.achApplyId,
          serialnumber: row.serialnumber,
          tabName: true
        }
      });
    },
    showCard(item, index) {
      this.cardIndex = index;
      this.cardInit = Number(item.init);
      this.isShowDetal = true;
      this.isShowApplyForm = item.achApplyId ? true :false;
      this.showTabDetal = "a";
      this.$nextTick(() => { 
        this.$refs.talentCard.getData(item.serialnumber, this.beEnd);
        this.$refs.talentCard.buttonShow = false;
        if(this.isShowApplyForm){
          this.$refs.MyAchievements.id = item.achApplyId;
          this.$refs.MyAchievements.userinfoItem.year = item.year;
          this.$refs.MyAchievements.getPDInfo(item.achApplyId, item.serialnumber);
        }
        });
    },
    showNewPage(row) {
      const href =
        "/1C8C01B41E2A5A25B6BC3751C28CCDCD/A3FFBEBFDB713E27/?pageLink=name1&plan=true&id=" +
        this.id +
        "&serialnumber=" +
        row.dirSupSerialnumber +
        "&pagename=" +
        row.dirSupName +
        "&beEnd=" +
        this.$route.query.beEnd;
      window.open(href, "_blank");
    },
    TableSelectCancelRow(selection, row) {
      this.achPeopleBoardList.forEach((el, index) => {
        if (el.id == row.id) {
          this.achPeopleBoardList.splice(index, 1);
        }
      });
    },
    peoOnSelectRow(selection, row) {
      if (!this.achPeopleBoardList.includes(row.id)) {
        this.achPeopleBoardList.push(row);
      }
    },
    selsetAll(selection) {
      this.data.forEach(el => {
        this.achPeopleBoardList.push(el);
      });
      let map = new Map();
      for (let item of this.achPeopleBoardList) {
        map.set(item.id, item);
      }
      this.achPeopleBoardList = [...map.values()];
    },
    cancelAll(selection) {
      this.data.forEach(row => {
        this.achPeopleBoardList.forEach((el, index) => {
          if (el.id == row.id) {
            this.achPeopleBoardList.splice(index, 1);
          }
        });
      });
    },
    allStatusSave() {
      if (this.achPeopleBoardList.length > 0) {
        let obj = {
          checkStatus: this.checkStatus,
          achPeopleBoardList: this.achPeopleBoardList
        };
        axios.post("/AchPeopleBoard/saveAchCheckStatus", obj).then(res => {
          if (res) {
            this.$Message.success("设置成功");
            this.achPeopleBoardList = [];
            this.getData(JSON.stringify(this.searchItem));
          }
        });
      } else {
        this.$Message.error(this.$t("Select_Employee"));
      }
    },
    pageSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.saveTable();
    },
    cardChange(val) {
      this.cardInit = val;
      let serialnumber = "";
      let achApplyId = "";
      this.allData.forEach((res, index) => {
        if (res.init == val) {
          serialnumber = res.serialnumber;
          achApplyId = res.achApplyId;
          this.isShowApplyForm = achApplyId ? true : false
          this.$refs.talentCard.getData(serialnumber);
          this.$refs.talentCard.buttonShow = false;
          this.$nextTick(() => { 
            if(this.isShowApplyForm){
              this.$refs.MyAchievements.id = achApplyId;
              this.$refs.MyAchievements.getPDInfo(achApplyId, serialnumber);
            }else{
              this.showTabDetal = "a";
            }
          })
        } else {
        }
      });
      // let serialnumber=this.data[this.cardIndex].serialnumber
      // let achApplyId=this.data[this.cardIndex].achApplyId
    },
    handleReset() {
      this.formItem = {};
      this.searchItem.year = this.date.dateVal(new Date(), "YYYY");
    }
  }
};
</script>

<style lang="scss" scoped>
.chartBox {
  width: 100%;
}
.chartMain {
  display: flex;
  flex-wrap: wrap;
  .chartTable {
    width: 100%;
  }
  >>> .ivu-table th {
    background: #006b37;
    color: #fff;
  }
  >>> .ivu-table td.demo-table-info-column {
    background-color: #006b37;
    color: #fff;
  }
}

@media screen and (max-width: 900px) {
  .chartBox {
    width: 100%;
  }
  .chartMain {
    flex-wrap: wrap;
    .chartTable {
      width: 100%;
    }
  }
}
#barLeftChart {
  zoom: 1.18 !important;
  div {
    width: 100%;
  }
}
>>> .ivu-page-simple .ivu-page-simple-pager input {
  padding: 4px !important;
}
>>> .ivu-modal-fullscreen .ivu-modal-body {
  overflow-y: hidden;
  height: 100% !important;
  max-height: 100%;
}
.tab {
  zoom: 1.1;
  >>> .taletTab.ivu-tabs-tabpane {
    height: 100vh !important;
    overflow-y: auto !important;
    overflow-x: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/PeopleBoardComponents/PerformanceEvaluation.vue